const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const setToken = (token) => {
  localStorage.setItem('vet_portal_token', token);
};

export const getToken = () => {
  return localStorage.getItem('vet_portal_token');
};

export const removeToken = () => {
  localStorage.removeItem('vet_portal_token');
};

export const setClinic = (clinic) => {
  localStorage.setItem('vet_portal_clinic', JSON.stringify(clinic));
};

export const getClinic = () => {
  const clinic = localStorage.getItem('vet_portal_clinic');
  return clinic ? JSON.parse(clinic) : null;
};

export const removeClinic = () => {
  localStorage.removeItem('vet_portal_clinic');
};

export const isAuthenticated = () => {
  return !!getToken();
};

export const logout = () => {
  removeToken();
  removeClinic();
};

export const authFetch = async (url, options = {}) => {
  const token = getToken();
  
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const response = await fetch(`${BACKEND_URL}${url}`, {
    ...options,
    headers,
  });
  
  if (response.status === 401) {
    logout();
    // Store message for login page to display
    localStorage.setItem('session_expired', 'true');
    window.location.href = '/login';
  }
  
  return response;
};
